exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sdr-disabled[data-v-78f77b6c]{background-color:rgba(0,0,0,.12)!important;color:rgba(0,0,0,.26)!important}", ""]);

// exports
